// extracted by mini-css-extract-plugin
module.exports = {"main":"main__2bds6","content":"content__1Qo4Z"};